import { SearchMicroViewService } from '../../search/services/SearchMicroViewService';

export function imgPath(img: string) {
  return `${SearchMicroViewService.instance.getUrlRootPath()}/search-dist/img/${img}`;
}

export function imgUrl(img: string) {
  const path = imgPath(img);
  return `url(${path})`;
}
